export default "__VITE_ASSET__D5yVY9Ux__"